import React, { useState } from 'react';
import { IoInformationCircle } from "react-icons/io5";
import Button from 'react-bootstrap/Button';
import { FaPencilAlt } from "react-icons/fa";
import { FaSimplybuilt } from "react-icons/fa6";
import Alert from 'react-bootstrap/Alert'; // Bootstrap alert component
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

export default function AddDepartments() {
  const [formData, setFormData] = useState({
    message: '', // Using 'message' for the department name input
  });
  const [successMessage, setSuccessMessage] = useState(''); // State for the success message
  const navigate = useNavigate(); // Initialize navigate function

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://backend.ems.uk.hiradentallab.com/api/departments/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: formData.message }), // Send department name to the backend
      });

      const result = await response.json();
      if (response.ok) {
        console.log('Department added successfully:', result);

        // Display success message
        setSuccessMessage('Department added successfully!');

        // Hide the message after 3 seconds and redirect
        setTimeout(() => {
          setSuccessMessage('');
          // Redirect to departments page with new department data
          navigate('/departments', { state: { newDepartment: result } });
        }, 3000);

        // Optionally, reset the form
        setFormData({ message: '' });
      } else {
        console.error('Error:', result.message);
      }
    } catch (error) {
      console.error('Error while adding department:', error);
    }
  };

  return (
      <div className='container-fluid'>
        <div>
          <h1 className="salary-title">
            <IoInformationCircle className="salary-icon" /> Departments Information
          </h1>
          <hr />
          <h2 className="salary-subtitle">
            <FaSimplybuilt className="salary-icon" /> Department Details
          </h2>
          <hr />
       
            {/* Show success message */}
            {successMessage && (
              <Alert variant="success" className="text">
                {successMessage}
              </Alert>
            )}
          <div className="table-container">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="message" style={{ fontWeight: 'bold' }}>
                  Department Name <span style={{ color: 'red' }}> *</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  className="form-control"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  style={{ height: '20px', width: '40%' }} // Adjust this value as needed
                ></textarea>
              </div>

              <div className="py-3">
                <Button variant="primary" type="submit">
                  <FaPencilAlt /> Add Department
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
  );
}
